import React from 'react'
import { useCurrentLocale } from '../src/contexts/CurrentLanguageContext'
import { useTranslate } from '../src/hooks/useTranslate'
import { CompositionFragment } from '../src/model/fragments'
import { getLocale } from '../src/model/locale'
import { Composition } from './Composition'

export interface CompositionsLayoutProps {
	compositions: CompositionFragment[]
}

export const CompositionsLayout: React.FunctionComponent<CompositionsLayoutProps> = ({
	compositions
}) => {
	const locale = useCurrentLocale()
	const translate = useTranslate()
	const [active, setActive] = React.useState<CompositionFragment | undefined>(undefined);

	return (
		<section className="compositionsLayout">
			<div className="compositionsLayout-in">
				{	compositions.map((composition) => (
					<>
						<Composition
							key={composition.id}
							active={composition.id == active?.id}
							toggle={() => composition.id == active?.id ? setActive(undefined) : setActive(composition)}
							name={getLocale(composition.locales, [locale])?.name}
							composition={composition}
						/>
					</>
				))}
			</div>
		</section>
	)
}
